import { createSelector } from 'reselect';

export const selectLists = state => state.lists;

export const selectCriteria = (state, criteria) => criteria;

export const selectTechnology = createSelector(
  [selectLists, selectCriteria],
  (lists, criteria) => {
    const { citiesWithFiber } = lists;
    const technology = Object.entries(citiesWithFiber).reduce(
      (result, entry) => {
        const [technologyName, citiesWithTechnology] = entry;
        if (citiesWithTechnology.includes(criteria.city)) {
          return technologyName;
        }
        return result;
      },
      'copper'
    );

    return technology;
  }
);

export const selectProductsByTechnology = createSelector(
  [selectTechnology, selectLists],
  (technology, lists) => lists[technology]
);

export const selectProductsByOrigin = createSelector(
  [selectProductsByTechnology, selectCriteria],
  (products, criteria) =>
    products.filter(item => item.productOrigin === criteria.productOrigin)
);

export const selectProductsByPlan = createSelector(
  [selectProductsByOrigin, selectCriteria],
  (products, criteria) => products.filter(item => item.plan === criteria.plan)
);

export const selectProductByAdditional = createSelector(
  [selectProductsByPlan, selectCriteria],
  (products, criteria) =>
    products.find(item => item.additional === criteria.additional)
);

export const selectProduct = createSelector(
  [selectProductsByPlan, selectProductByAdditional, selectCriteria],
  (productsByPlan, productByAdditional, criteria) => {
    if (criteria.additional) {
      return productByAdditional;
    } else if (productsByPlan.length === 1) {
      return productsByPlan[0];
    } else {
      return null;
    }
  }
);
